exports = module.exports = require("../../../../_css-loader@0.28.4@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".am-wingblank {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n.am-wingblank.am-wingblank-sm {\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.am-wingblank.am-wingblank-md {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n.am-wingblank.am-wingblank-lg {\n  margin-left: 15px;\n  margin-right: 15px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.4@css-loader!./node_modules/_postcss-loader@2.0.6@postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/_less-loader@4.1.0@less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A"}}!./node_modules/_antd-mobile@2.2.2@antd-mobile/lib/wing-blank/style/index.less
// module id = 340
// module chunks = 0